import { combineReducers } from 'redux';

import rootReducer from './rootReducer';
import userReducers from '../../user/containers/reducers';
import auth from './authReducer';
import signUp from './signUpReducer';
import managePassword from './passwordReducer';

const createRootReducer = (routerReducer) =>
  combineReducers({
    router: routerReducer,
    data: rootReducer,
    auth,
    signUp,
    managePassword,
    ...userReducers,
  });

export default createRootReducer;
